// extracted by mini-css-extract-plugin
module.exports = {"box":"Box-module--box--1Uqm-"};